import HttpService from "./HttpService";

const httpService = HttpService.getInstance();

export default {
  changePassword: (data) => httpService.authCall("POST", "/api/account/change_password", {data}),
  changeAvatar: (data, body) => httpService.authCall("POST", "/api/account/change-avatar", {data, ...body}),
  profile: () => httpService.authCall("GET", "/api/account/profile"),
}
